<template>
	<Popper :placement="placement" :isVisible="isVisible && enabled && !isMobile" :modifiers="modifiers">
		<div
			@mouseenter="isVisible = true"
			@mouseleave="isVisible = false"
			@focus="isVisible = true"
			@blur="isVisible = false"
		>
			<slot></slot>
		</div>

		<template #popup>
			<div v-if="isVisible" class="base-tooltip">
				<slot name="text">{{ text }}</slot>
			</div>
		</template>
	</Popper>
</template>

<script>
import Popper, {placements} from 'shared/components/Popper.vue'
import {useWindowSize} from 'shared/composables/useWindowSize'

export default {
	components: {
		Popper,
	},
	props: {
		placement: {
			type: String,
			validator: value => placements.includes(value),
			default: () => 'top',
		},
		text: {type: String, default: ''},
		enabled: {type: Boolean, default: true},
		modifiers: {
			type: Array,
			default: () => [],
		},
	},
	setup() {
		const {isMobile} = useWindowSize()
		return {isMobile}
	},
	data() {
		return {
			isVisible: false,
		}
	},
}
</script>

<style>
.base-tooltip {
	font-size: 13px;
	background-color: #000;
	color: #eaeaea;
	border-radius: 4px;
	padding: 4px 8px;
	white-space: nowrap;
	border: 1px solid #383838;
	box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.3);
	max-width: 100%;
	overflow: hidden;
	text-overflow: ellipsis;
}
</style>
